import { useState, useEffect } from "react";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          return 100;
        } else {
          return prevProgress + 30;
        }
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div
      className="turbolinks-progress-bar"
      style={{
        zIndex: 10000000000000,
        position: "fixed",
        top: 0,
        left: 0,
        width: `${progress}vw`,
        opacity: progress === 100 ? 0 : 1,
      }}
    ></div>
  );
};

export default Loader;
